import React from 'react';
import { Grid, Divider } from '@material-ui/core';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import ValueField from 'core/components/value-field';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import { labelStyleMap, causeOfLossMap } from './constants';
import { formatClaimNumber } from './claim-number-formatter';
import useStyles from './claims.styles';

const ClaimField = ({ label, value, xs, className }) => (
  <Grid item xs={xs || 4}>
    <ValueField label={label} value={value} className={className} />
  </Grid>
);

const ExternalClaimDetail = observer(function ExternalClaimDetail({ claim, open, hideExternalClaimDetail }) {
  const classes = useStyles();
  return (
    <BaseDialog open={open} onClose={hideExternalClaimDetail} size="md">
      <Label type="subtitle">Claim {formatClaimNumber(claim.claimNumber, claim.TPA)}</Label>
      <Grid container flex="row" alignItems="baseline">
        <Grid item>
          <Label type="infoLabel">{'Status '}</Label>
        </Grid>
        <Grid item>
          <Label type={`${labelStyleMap[claim.status || 'UNKNOWN']}Medium`}>{claim.status || 'Unknown'}</Label>
        </Grid>
      </Grid>
      <div className={classes.spacing}>
        <Grid container flex="row" spacing={2}>
          <Grid container item flex="row" xs={12}>
            <ClaimField label="Date of Loss" value={claim.lossDate} />
            <ClaimField label="TPA Name" value={claim.TPA} />
          </Grid>
          <ClaimField label="Coverage" value={claim.coverage} />
          <ClaimField
            label="Cause of Loss"
            value={causeOfLossMap[claim.cause] || claim.cause}
            className={classes.wrapText}
          />
          <ClaimField label="Claim Type" value={claim.claimType || 'Unspecified'} />
        </Grid>
      </div>
      <Divider variant="middle" />
      <div className={classes.spacing}>
        <Grid container flex="row" spacing={2}>
          <Grid item xs={12}>
            <Label type="formSubTitleLight">Adjuster</Label>
          </Grid>
          <ClaimField label="Name" value={claim.adjusterName} xs={6} />
          <ClaimField label="Phone Number" value={claim.adjusterPhone} xs={6} />
          <ClaimField label="Email" value={claim.adjusterEmail} xs={6} />
        </Grid>
      </div>
    </BaseDialog>
  );
});

ExternalClaimDetail.propTypes = {
  claim: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  hideExternalClaimDetail: PropTypes.func.isRequired
};

export default ExternalClaimDetail;
